import { render, staticRenderFns } from "./OdontogramaNino.vue?vue&type=template&id=0fad8945&scoped=true"
import script from "./OdontogramaNino.vue?vue&type=script&lang=js"
export * from "./OdontogramaNino.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaNino.vue?vue&type=style&index=0&id=0fad8945&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad8945",
  null
  
)

export default component.exports